import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loading: false,
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    LOAD: (s, data) => (s.loading = data),
  },

  actions: {
    async createAffiliate({ commit }, payload) {
      commit("LOAD", true);
      try {
        const res = await this.$api.post("/v1/portal/affiliates", payload);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD", false);
      }
    },
    async updateAffiliate({ commit }, payload) {
      commit("LOAD", true);
      try {
        const { code, ...restPayload } = payload;
        const res = await this.$api.put(
          `/v1/portal/affiliates/${code}`,
          restPayload
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD", false);
      }
    },
    async deleteAffiliate({ commit }, id) {
      commit("LOAD", true);
      try {
        const res = await this.$api.delete(`/v1/portal/affiliates/${id}`);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD", false);
      }
    },
  },
};
